import React, {  useState, useEffect } from "react";
import { connect } from "react-redux";
import Sidebar from "../../layout/Sidebar";
import Navbar from "../../layout/Navbar";
// import Maincontent from "./Maincontent";
import { getAllChartofaccounts, getAllChartofaccountsbyContact } from "../../../actions/chartofaccountsAction";
import { resetAllChartofaccounts } from "../../../actions/chartofaccountsAction";
import { getJournalSearchResult } from "../../../actions/journalAction";
import ContctSearch from "./ContctSearch";
import moment from "moment";

import { Layout, Breadcrumb, Card, Typography, Row, Col, Tabs } from "antd";
import AccountPieChart from "./AccountPieChart";
import TransactionHistoryChart from "./TransactionHistoryChart";

const { Content } = Layout;
const { Text } = Typography;
const { TabPane } = Tabs;




const SupplierReport = ({getJournalSearchResult, getAllChartofaccounts , getAllChartofaccountsbyContact}) => {
  const [updatelist, setUpdatelist] = useState(true);
  const [reload, setReload] = useState(true);
  const [journals, setJournals] = useState([]);
  const [charts, setCharts] = useState([]);
  const [contact, setContact] = useState(null);
  const [selectedChart, setSelectedChart] = useState({});

  useEffect(() => {
    if (contact) {
      getAllChartofaccountsbyContact(contact.id).then((result) => {
        setCharts(result.data);
        // console.log(result)
      });
      getJournalSearchResult("", "", "", "", "", "", "", "", "", contact.id).then((result) => {
        setJournals(result);
        // console.log(result)
      });
    }else{
      setCharts([]);
      setJournals([]);
    }
    
  }, [reload, contact]);

  return (
    <>
      <Layout className="window-frame">
        <Sidebar />
        <Layout className="site-layout">
          <Navbar />
          <Content className="main-frame-content">
            <Breadcrumb style={{ margin: "16px 0" }}>
              <Breadcrumb.Item>Contact</Breadcrumb.Item>
              <Breadcrumb.Item>Supplier Report</Breadcrumb.Item>
            </Breadcrumb>
            {/* <Maincontent /> */}
            <Row>
              <Col span={10}>
                <Row>
                  <Col span={24}>
                    <Card 
                      bordered={true}
                      style={{
                          border: "1px solid whitesmoke",
                      }}
                    >
                      <ContctSearch
                        contact={contact}
                        setContact={setContact}
                        reload={reload}
                        setReload={setReload}
                      />
                    </Card>
                  </Col>
                </Row>
                <Row>
                      {charts.map((chart) => {
                        return (
                          <Col span={12} key={chart.id}>
                            <Card
                              bordered={true}
                              onClick={() => setSelectedChart(chart)}
                              style={{
                                border: "1px solid whitesmoke",
                                cursor: "pointer",
                                background: selectedChart.id === chart.id ? "#efd685ff" : "white"
                              }}
                            >
                              <h4 style={{ color: "#7474f7" }}>{chart.name}</h4>
                              <h2 style={{ color: "black" }}>
                                {Math.abs(chart.amount).toFixed(2)}{" "}
                                <span style={{ color: chart.status === "Debit" ? "#007bff" : "#dc3545", fontSize: "16px" }}>
                                  {chart.status === "Debit" ? "Dr" : "Cr"}
                                </span>
                              </h2>
                            </Card>
                          </Col>
                        );
                      })}
                    </Row>
                    {charts.length > 0 && (
                      <Row style={{ marginTop: "20px" }}>
                        <Col span={24}>
                          <Card bordered={true} title="Account Distribution" style={{ border: "1px solid whitesmoke" }}>
                            <AccountPieChart data={charts} />
                          </Card>
                        </Col>
                      </Row>
                    )}
                  </Col>
                  <Col span={14}>
                    <Row>
                      {charts.map((chart) => {
                        if (selectedChart.id !== chart.id) {
                          return null;
                        }
                        return (
                          <Col span={24} key={chart.id}>
                            <Card
                              bordered={true}
                              style={{
                                border: "1px solid whitesmoke",
                              }}
                            >
                              <Tabs defaultActiveKey="1">
                                <TabPane tab="Ledger Table" key="1">
                                  <h3>{chart.name}</h3>
                                  <table className="history_table">
                                    <thead>
                                      <tr>
                                        <th style={{ textAlign: "left" }}>Date</th>
                                        <th style={{ textAlign: "left" }}>Details</th>
                                        <th style={{ textAlign: "right" }}>Debit</th>
                                        <th style={{ textAlign: "right" }}>Credit</th>
                                        <th style={{ textAlign: "right" }}>Balance</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {(() => {
                                        let total = 0;
                                        return journals.map((journal) => {
                                          if (journal.chartofaccount === chart.id) {
                                            if (journal.increase) {
                                              total += parseFloat(journal.amount);
                                            } else {
                                              total -= parseFloat(journal.amount);
                                            }

                                            const formatBalance = (amount, normallyDebit) => {
                                              if (amount === 0) return "0.00";
                                              const absAmount = Math.abs(amount).toFixed(2);
                                              const side = amount > 0 ? (normallyDebit === "Debit" ? "Dr" : "Cr") : (normallyDebit === "Debit" ? "Cr" : "Dr");
                                              const color = side === "Dr" ? "#007bff" : "#dc3545";
                                              return (
                                                <span>
                                                  {absAmount} <span style={{ color, fontWeight: "500" }}>{side}</span>
                                                </span>
                                              );
                                            };

                                            return (
                                              <tr key={journal.id}>
                                                <td style={{ width: "12%" }}>{moment(journal.created).format("DD-MM-YYYY")}</td>
                                                <td>{journal.details}</td>
                                                <td style={{ textAlign: "right", color: "#007bff" }}>
                                                  {journal.type === "Debit" ? journal.amount : ""}
                                                </td>
                                                <td style={{ textAlign: "right", color: "#dc3545" }}>
                                                  {journal.type === "Credit" ? journal.amount : ""}
                                                </td>
                                                <td style={{ textAlign: "right" }}>{formatBalance(total, chart.normally_Debit)}</td>
                                              </tr>
                                            );
                                          }
                                          return null;
                                        });
                                      })()}
                                    </tbody>
                                    <tfoot>
                                      {(() => {
                                        let total = 0;
                                        journals.forEach(journal => {
                                          if (journal.chartofaccount === chart.id) {
                                            if (journal.increase) {
                                              total += parseFloat(journal.amount);
                                            } else {
                                              total -= parseFloat(journal.amount);
                                            }
                                          }
                                        });
                                        return (
                                          <tr style={{ borderTop: "2px solid #f0f0f0", fontWeight: "bold" }}>
                                            <td></td>
                                            <td>Total</td>
                                            <td style={{ textAlign: "right" }}></td>
                                            <td style={{ textAlign: "right" }}></td>
                                            <td style={{ textAlign: "right" }}>
                                              {Math.abs(total).toFixed(2)}{" "}
                                              <span style={{ color: (total >= 0 ? (chart.normally_Debit === "Debit" ? "Dr" : "Cr") : (chart.normally_Debit === "Debit" ? "Cr" : "Dr")) === "Dr" ? "#007bff" : "#dc3545" }}>
                                                {total >= 0 ? (chart.normally_Debit === "Debit" ? "Dr" : "Cr") : (chart.normally_Debit === "Debit" ? "Cr" : "Dr")}
                                              </span>
                                            </td>
                                          </tr>
                                        );
                                      })()}
                                    </tfoot>
                                  </table>
                                </TabPane>
                                <TabPane tab="Daily Analytics" key="2">
                                  <h3>{chart.name} - Transaction Mix</h3>
                                  <TransactionHistoryChart journals={journals.filter(j => j.chartofaccount === chart.id)} />
                                </TabPane>
                              </Tabs>
                            </Card>
                          </Col>
                        );
                      })}
                </Row>
              </Col>
            </Row>
            
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default connect(null, {getJournalSearchResult, getAllChartofaccounts, getAllChartofaccountsbyContact})(SupplierReport);
